export const headers = [
    {
      text: 'Nome',
      align: 'start',
      sortable: true,
      value: 'name',
      width: '15%'
    },
    {
      text: 'Telefone',
      align: 'start',
      sortable: true,
      value: "phone", 
      width: '10%'
    },
    {
      text: 'CPF/CNPJ',
      align: 'start',
      sortable: true,
      value: 'cpfCnpj',
      width: '15%'
    },
    {
      text: 'Data de Nascimento',
      align: 'start',
      sortable: true,
      value: 'birthDate',
      width: '10%'
    },
    {
      text: 'E-mail',
      align: 'start',
      sortable: true,
      value: 'email',
      width: '15%'
    },
    {
      text: 'Ações',
      value: 'actions',
      align: 'right',
      sortable: false,
      width: '10%'
    }
  ]
  
  